import React from 'react';
import { TabState } from '../../../../types';
import { ReportView } from '../../ReportView';
import { useReportActions } from '../../../contexts/ReportContext';
import { useProjectData } from '../../../stores/hooks/useProjectData';
import * as styles from '../../../tab-system/TabContainer.css.ts';

interface ReportTabContentProps {
  tab: TabState;
}

export const ReportTabContent: React.FC<ReportTabContentProps> = ({ tab }) => {
  // Hooksを使用してデータを取得
  const { project } = useProjectData();
  const {
    availableReports,
    onRenameReport,
    onDeleteReportElement,
    onUpdateReportElement,
    onContentChange,
    onAddElement
  } = useReportActions();
  
  // タブのメタデータからレポートIDを取得
  const reportId = tab.metadata?.reportId;
  
  // レポートを検索
  const report = availableReports?.find(r => r.id === reportId) || null;
  
  if (!project) {
    return (
      <div data-testid="report-content" className={styles.tabContentScrollable}>
        <div className={styles.reportTabContent}>
          <p>No project loaded. Please load a project to view reports.</p>
        </div>
      </div>
    );
  }

  if (!report) {
    return (
      <div data-testid="report-content" className={styles.tabContentScrollable}>
        <div className={styles.reportTabContent}>
          <p>Report not found. Report ID: {reportId || 'unknown'}</p>
          <p>Available reports: {availableReports?.length || 0}</p>
        </div>
      </div>
    );
  }

  // レポート全体のスクロールコンテキストを統一するため、
  // tabContentScrollableクラスを直接ReportViewに適用
  return (
    <ReportView
      project={project}
      report={report}
      // レポート操作関数
      onElementUpdate={reportId && onUpdateReportElement ?
        (elementId: string, updates: Record<string, unknown>) => onUpdateReportElement(reportId, elementId, updates) : undefined}
      onDeleteElement={reportId && onDeleteReportElement ?
        (elementId: string) => onDeleteReportElement(reportId, elementId) : undefined}
      onReportNameChange={reportId && onRenameReport ?
        (newName: string) => onRenameReport(reportId, newName) : undefined}
      onAddElement={reportId && onAddElement ?
        (elementType: string, elementData?: Record<string, unknown>) => onAddElement(reportId, elementType, elementData) : undefined}
      onContentChange={reportId && onContentChange ?
        (content: string) => onContentChange(reportId, content) : undefined}
    />
  );
};